var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Utils from '@datocms/rest-client-utils';
import BaseResource from '../../BaseResource';
var ScheduledPublication = /** @class */ (function (_super) {
    __extends(ScheduledPublication, _super);
    function ScheduledPublication() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new scheduled publication
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/scheduled-publication/create
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    ScheduledPublication.prototype.create = function (itemId, body) {
        return this.rawCreate(Utils.toId(itemId), Utils.serializeRequestBody(body, {
            type: 'scheduled_publication',
            attributes: ['publication_scheduled_at', 'selective_publication'],
            relationships: [],
        })).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Create a new scheduled publication
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/scheduled-publication/create
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    ScheduledPublication.prototype.rawCreate = function (itemId, body) {
        return this.client.request({
            method: 'POST',
            url: "/items/".concat(itemId, "/scheduled-publication"),
            body: body,
        });
    };
    /**
     * Delete a scheduled publication
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/scheduled-publication/destroy
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    ScheduledPublication.prototype.destroy = function (itemId) {
        return this.rawDestroy(Utils.toId(itemId)).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Delete a scheduled publication
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/scheduled-publication/destroy
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    ScheduledPublication.prototype.rawDestroy = function (itemId) {
        return this.client.request({
            method: 'DELETE',
            url: "/items/".concat(itemId, "/scheduled-publication"),
        });
    };
    ScheduledPublication.TYPE = 'scheduled_publication';
    return ScheduledPublication;
}(BaseResource));
export default ScheduledPublication;
//# sourceMappingURL=ScheduledPublication.js.map